export const HERO_VIDEO_MOBILE_MEDIA = "(max-width: 991px)";
/** Transparent 1×1 GIF — baseline poster so CSS `--hero-poster` backgrounds show through. */
export const HERO_VIDEO_BASELINE_POSTER = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
export function isHeroMobileViewport() {
    return window.matchMedia(HERO_VIDEO_MOBILE_MEDIA).matches;
}
export function selectHeroVideoSource(desktopUrl, mobileUrl) {
    if (mobileUrl && isHeroMobileViewport()) {
        return mobileUrl;
    }
    return desktopUrl;
}
/**
 * Picks desktop or mobile URL from data attributes and loads it on the video element.
 * Browsers ignore media on <source> inside <video>, so source selection must be explicit.
 */
export function applyHeroVideoSource(video) {
    const src = selectHeroVideoSource(video.getAttribute("data-src-video"), video.getAttribute("data-src-video-mobile"));
    if (!src) {
        return false;
    }
    const resolved = new URL(src, document.baseURI).href;
    if (video.currentSrc === resolved || video.src === resolved) {
        return false;
    }
    video.querySelectorAll("source").forEach((source) => source.remove());
    video.src = src;
    video.load();
    return true;
}
export function applyHeroVideoPoster(video, wrapper) {
    const mobilePoster = video.getAttribute("data-poster-mobile") ||
        wrapper?.getAttribute("data-poster-mobile") ||
        video.parentElement?.closest("[data-poster-mobile]")?.getAttribute("data-poster-mobile");
    if (mobilePoster && isHeroMobileViewport()) {
        video.poster = mobilePoster;
    }
    else {
        video.poster = HERO_VIDEO_BASELINE_POSTER;
    }
}
